export default __webpack_public_path__ + "static/media/NormalMap7.dfaca194.png";